<template>
    <div class="comment-modal" v-if="isModalOpen">
        <div class="comment-modal__body" v-html="modalMessage"></div>
        <div class="comment-modal__button" @click="hideModal"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {HIDE_MODAL_ACTION} from "VueApps/comments/actions/actions";

    export default {
        name: "ModalWithError",
        computed: {
            ...mapState([
                'isModalOpen',
                'modalMessage'
            ])
        },
        methods: {
            hideModal: function () {
                this.$store.dispatch(HIDE_MODAL_ACTION);
            }
        }
    }
</script>

<style scoped>

</style>
